'use client';
import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_without_properties_loose } from "@swc/helpers/_/_object_without_properties_loose";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Input } from '@kamio/ui/components/input';
import { cn } from '@kamio/ui/lib/utils';
import { maskitoGetCountryFromNumber, maskitoPhoneOptionsGenerator } from '@maskito/phone';
import { useMaskito } from '@maskito/react';
import metadata from 'libphonenumber-js/min/metadata';
import { CheckIcon } from 'lucide-react';
import { useMemo, useState } from 'react';
import 'flag-icons/css/flag-icons.min.css';
const meta = metadata;
const options = maskitoPhoneOptionsGenerator({
    countryIsoCode: 'ZA',
    metadata: meta,
    strict: false
});
export const PhoneInput = (_0)=>{
    let { className, verified } = _0, props = _object_without_properties_loose(_0, [
        "className",
        "verified"
    ]);
    var _ref;
    const maskedInputRef = useMaskito({
        options
    });
    const [v, setV] = useState((_ref = props == null ? void 0 : props.value) != null ? _ref : '');
    const countryIsoCode = useMemo(()=>maskitoGetCountryFromNumber(v, meta), [
        v
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('flex w-full items-center space-x-2', className),
        children: [
            /*#__PURE__*/ _jsx(Input, _extends({}, props, {
                ref: maskedInputRef,
                onInput: (e)=>{
                    var _props_onChange;
                    setV(e.target.value);
                    props == null ? void 0 : (_props_onChange = props.onChange) == null ? void 0 : _props_onChange.call(props, e);
                }
            })),
            verified && /*#__PURE__*/ _jsx(CheckIcon, {
                className: "text-success h-5 w-5"
            }),
            countryIsoCode && /*#__PURE__*/ _jsx("span", {
                className: `fi fi-${countryIsoCode == null ? void 0 : countryIsoCode.toLowerCase()} inline`
            })
        ]
    });
};
